import { Context } from '@nuxt/types';

export default async function(context: Context) {
  const { route, redirect } = context;

  if (route.path.endsWith('/index.html')) {
    redirect(route.path.replace('index.html', ''));
  }
}
